<template>
  <v-row justify="center">
    <v-dialog v-if="!loadingdata" v-model="dialog" persistent max-width="400">
      <v-card>
        <v-card-title class="headline">{{ title | translate }}</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text v-if='redirect!=true' @click="closeBox">{{ 'Close' | translate }}</v-btn>
          <v-btn color="green darken-1" text @click="handleAction">{{ buttonTitle | translate }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-overlay :absolute="absolute" :value="(loadingdata && dialog)">
      <v-layout row justify-center v-if="loadingdata">
        <v-dialog v-model="loadingdata" persistent fullscreen content-class="loading-dialog">
          <v-container fill-height>
            <v-layout row justify-center align-center>
              <v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular>
            </v-layout>
          </v-container>
        </v-dialog>
      </v-layout>
    </v-overlay>
  </v-row>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "Dialogbox",
  computed: {
    ...mapGetters(["loadingdata"])
  },
  methods: {
    closeBox() {
      this.$emit("closing");
    },
    handleAction() {
      if(this.deleteuser === true){
        this.$emit("deleteuser");
      }
      else if(this.deletecard === true){
        this.$emit("deletecard")
      }
      else if(this.redirect === true){
        this.$emit('redirect')
      }
    }
  },
  data: () => ({
    absolute: false,
  }),  
  props: {
    dialog: Boolean,
    buttonTitle: String,
    title: String,
    deleteuser: Boolean,
    deletecard: Boolean,
    redirect: Boolean,
    closestatus: Boolean
  }
};
</script>